// @ts-ignore
/* eslint-disable */
import { request } from '../../request'

/** No comments are provided by the backend POST /webmcp/call */
export async function webMcpControllerCall(
  body: API.WebMcpCallDto,
  options?: { [key: string]: any },
) {
  return request<any>('/webmcp/call', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  })
}

/** No comments are provided by the backend GET /webmcp/tools */
export async function webMcpControllerTools(options?: { [key: string]: any }) {
  return request<any>('/webmcp/tools', {
    method: 'GET',
    ...(options || {}),
  })
}
